import styled from 'styled-components';

type TypeIconContainer = {
    hoverColor: string;
}

const IconContainer = styled.span<TypeIconContainer>`
    display: flex;
    align-items: center;

    &:hover{
        cursor: pointer;
        >svg path {
            fill: ${(props) => props.hoverColor }
        }
    }
`;

type TypeProps = {
    onClick?: () => void;
    color?: string;
    onHoverColor?: string;
    style?: React.CSSProperties;
}

const MenuIcon = ({ onClick= ()=>{}, color, onHoverColor, style }: TypeProps) => {
    return (
        <IconContainer style={style || {}} hoverColor={onHoverColor || color || "#000"} onClick={onClick}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
            >
                <path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" fill={color || "#000"}/>
            </svg>
        </IconContainer>
    )
}

export default MenuIcon;
